(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("transaction", {
            parent: "app",
            url: "/transaction?page?status?date",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/transaction/transaction.html",
                    controller: "TransactionController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
